import { App } from 'vue';
import { Router } from 'vue-router';
import { I18n } from 'vue-i18n';
import {
  arraySize, crmLink, equalSets, isEmpty,
} from '@/components/utils';

export default {

  install: (app: App, options: { router: Router, i18n: I18n }) => {
    // inject a globally available methods ------------

     
    app.config.globalProperties.$arraySize = arraySize;
    app.config.globalProperties.$equalSets = equalSets;
    app.config.globalProperties.$isEmpty = isEmpty;

    app.config.globalProperties.crmLink = crmLink;
     

    /**
       * go back to last page or to main-page if history is empty
       */
    app.config.globalProperties.goBack1Page = (_defaultPage?: string) => {
      if (window.history.state?.back && !window.history.state.back.startsWith('/openid-connect-callback')) {
        // if there's browser history & last page was not the callback -> go back in history
        options.router.back();
      } else {
        // else -> go to main page
        options.router.push(_defaultPage ?? `/${options.i18n.global.locale}/members`);
      }
    };
  },

};

/**
 * this informs typescript these functions are available globally in all components
 */
declare module 'vue' {
  interface ComponentCustomProperties {
    $arraySize: (a?: unknown[]) => number;
    $equalSets: (x: [], y: []) => boolean;
    $isEmpty: (a: unknown[]) => boolean;

    crmLink(crmId: string, entity?: 'contact' | 'account'): string;

    goBack1Page: (_defaultPage?: string) => void;
  }
}
